module.exports = __webpack_public_path__ + "img/yuyuko saigyouji tiny ghost mistress.4bf7606f.png";